import React from 'react';
import { COLORS, FONTS } from '../../styles/tokens';
import type { ColorTheme } from '../../styles/tokens';

interface ChatInputProps {
  value: string;
  placeholder: string;
  disabled: boolean;
  isDark: boolean;
  colors: ColorTheme;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

/**
 * Text field + send button for the deploy chat. Keeps composition inside the
 * parent component by surfacing only controlled state.
 */
export function ChatInput(props: ChatInputProps): React.JSX.Element {
  const canSend = !props.disabled && props.value.trim().length > 0;
  return (
    <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
      <input
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter' && canSend) props.onSubmit();
        }}
        placeholder={props.placeholder}
        disabled={props.disabled}
        style={{
          flex: 1,
          height: '40px',
          padding: '0 14px',
          borderRadius: '8px',
          border: `1px solid ${props.colors.border}`,
          backgroundColor: props.isDark ? COLORS.dark.card : COLORS.light.card,
          color: props.colors.text,
          fontFamily: FONTS.body,
          fontSize: '13px',
          outline: 'none',
        }}
      />
      <button
        onClick={props.onSubmit}
        disabled={!canSend}
        style={{
          height: '40px',
          padding: '0 20px',
          borderRadius: '8px',
          border: 'none',
          background: canSend
            ? (props.isDark
              ? 'linear-gradient(90deg, #0266C6, #00407D)'
              : 'linear-gradient(90deg, #01A9ED, #0165C6)')
            : props.colors.border,
          color: '#FFF',
          fontFamily: FONTS.heading,
          fontSize: '11px',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          cursor: canSend ? 'pointer' : 'not-allowed',
        }}
      >
        Send
      </button>
    </div>
  );
}
